import React, { Dispatch, SetStateAction, useContext } from 'react';
import { useRouter } from 'next/router';
import ButtonAsLink from 'components/ButtonAsLink/ButtonAsLink';
import useFormLogic from 'components/Modals/AuthModal/hooks/useFormLogic';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';
import { appAuthContext } from 'context/AuthContext';
import useQuery from 'utils/useQuery';
import getUser from 'api/requests/getUser';
import { AuthModalProps } from 'components/Modals/AuthModal/AuthModal.types';
import BottomSlider from '../BottomSlider/BottomSlider';
import EntryScreen from '../EntryScreen/EntryScreen';
import ServiceAuthModalDecorations from '../ServiceAuthModalDecorations/ServiceAuthModalDecorations';
import styles from './AuthServiceModalContent.module.css';

type Props = {
  handleClose: () => void;
  setUnsuccessfulAuth: Dispatch<SetStateAction<boolean>>;
  unsuccessfulAuth: boolean;
  entryPoint: AuthModalProps['entryPoint'];
};

const AuthServiceModalContent = ({
  handleClose,
  setUnsuccessfulAuth,
  unsuccessfulAuth,
  entryPoint,
}: Props) => {
  const { openRegistration } = useFormLogic();
  const { sendEvent } = useClickStreamEvent();
  const { setUser } = useContext(appAuthContext);
  const router = useRouter();

  const setUserInfo = async () => {
    const data = await getUser();
    if (data) {
      setUser({ ...data });
      await router.replace(router.asPath);
      handleClose();
    }
  };

  const successRegistration = async () => {
    await sendEvent({
      eventType: 'click',
      eventInfo: 'otvety_reg_success_service',
      customDimentions: {
        cd1: JSON.stringify({ source: entryPoint }),
      },
    });

    setUserInfo();
  };

  const registrationBtnHandler = () => {
    sendEvent({
      eventType: 'click',
      eventInfo: 'otvety_reg_open_service',
      customDimentions: {
        cd1: JSON.stringify({ source: entryPoint }),
      },
    });
    openRegistration(successRegistration);
  };
  return (
    <>
      <div className={styles.bottom_slider}>
        <BottomSlider />
      </div>
      <div className={styles.left_side}>
        <ServiceAuthModalDecorations />
      </div>
      <div className={styles.right_side}>
        <div className={styles.form_fullscreen}>
          <EntryScreen
            setUserInfo={setUserInfo}
            setUnsuccessfulAuth={setUnsuccessfulAuth}
            unsuccessfulAuth={unsuccessfulAuth}
            entryPoint={entryPoint}
            version="service"
          />

          <div className={styles.footer}>
            Впервые на Учи.ру?&nbsp;
            <ButtonAsLink onClick={registrationBtnHandler}>Зарегистрируйся!</ButtonAsLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthServiceModalContent;
